<template>
    <section class="xnax-login">
        <div class="login-rubies">
<!--            <p class="login-intro">Enrollment</p>-->
            <p class="login-intro">Setup Account Number</p>
            <div class="login-form">
                <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png" @click="goHome" alt="">

                <div v-if="setAccountStage === 0">

                    <div class="col-sm-12">

                        <!--Stage 1-->
                        <div>
                            <div class="form">
                                <div class="mb-3 mt-4">

                                    <!-- Checkbox Switch -->
                                    <div class="checkbox-row">
                                        <div class="checkbox-container">
                                            <label class="checkbox" for="choose-account-no">
                                                <input type="checkbox" id="choose-account-no" value="ios" v-on:change="createAccountType('1')">
                                                <div class="checkbox-box" aria-hidden="true">
                                                    <div class="checkbox-outer">
                                                        <div class="checkbox-inner"></div>
                                                    </div>
                                                </div>
                                                <span class="checkbox-label">
                                                    <small class="main-big">I want to choose my account number</small>
                                                    <small class="sub-small">Preferred Account Number</small>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- End Checkbox Switch -->
                                    <!-- Checkbox Switch -->
                                    <div class="checkbox-row">
                                        <div class="checkbox-container">
                                            <label class="checkbox" for="random-account-no">
                                                <input type="checkbox" id="random-account-no" value="ios" v-on:change="createAccountType('2')">
                                                <div class="checkbox-box" aria-hidden="true">
                                                    <div class="checkbox-outer">
                                                        <div class="checkbox-inner"></div>
                                                    </div>
                                                </div>
                                                <span class="checkbox-label">
                                                    <small class="main-big">Rubies, give me a random account</small>
                                                    <small class="sub-small">Automatic Account Number</small>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="alter-links pt-2">
                                    <!--<a href="#">Forgot Password?</a>-->
                                    <a @click="updateEnrollComponent('stagetwo')" class=" mb-2">< Back</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="setAccountStage === 1">
                    <!--Stage 2-->
                    <form class="form" @submit.prevent="verifyChosenAccountNumber">
                        <div v-if="alert.show" class="alert-box">
                            <div class="row">
                                <div class="col-sm-12">
                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                        {{alert.message}}
                                    </ui-alert>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 form-group mb-2 pr-0 pl-0">
                            <label for="chosenAccountNumber" class="form-label">Preferred Account Number</label>
                            <input
                                    type="text" class="form-input form-control" id="chosenAccountNumber" name="chosenAccountNumber"
                                    placeholder="Preferred Account Number" v-model="chosenAccountNumber"
                                    v-on:keypress="checkAccountNumberLength($event)"
                                    v-validate="'required|numeric|max:10|min:10'" required
                                    data-vv-name="Preferred Account Number"
                            >
                            <span v-show="errors.has('chosenAccountNumber')" class="error-span is-danger">{{ errors.first('chosenAccountNumber') }}</span>
                        </div>

                        <div class="col-md-12 pr-0 pl-0">
                            <button type="submit" class="btn btn-primary btn-xnax-login ">Proceed</button>
                        </div>

                        <div class="alter-links">
                            <!--<a href="#">Forgot Password?</a>-->
                            <a @click="setAccountStage = 0" class="mb-2">< Back</a>
                        </div>
                    </form>
                </div>

                <div v-if="setAccountStage === 2">
                    <div class="col-12 no-pad">



                        <div v-if="account !== chosenAccountNumber">
                            <p class="pageHeaderP">
                                {{chosenAccountNumber}} is already taken but the next best
                                thing is
                                <!--<span>-->
                                <!--<span>{{verifiedAccountNumberBreakDown.one_9}}</span>-->
                                <!--<span style="color: #c02529">-->
                                    <!--{{verifiedAccountNumberBreakDown.nine_10}}</span>-->
                            <!--</span>.-->
                                <!--Please click continue to proceed.-->
                                <!--<span-->
                                        <!--class="toolTips fa fa-info"-->
                                        <!--v-tooltip.bottom="toolTip.msg"-->
                                <!--&gt;</span>-->
                            </p>
                        </div>
                        <div v-else>
                            <p class="pageHeaderP">
                                {{account}} is available.
                                <!--<span-->
                                        <!--class="toolTips fa fa-info"-->
                                        <!--v-tooltip.bottom="toolTip.msg"-->
                                <!--&gt;</span>-->
                            </p>
                        </div>

                        <div v-if="alert.show" class="alert-box">
                            <div class="row">
                                <div class="col-sm-12">
                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                        {{alert.message}}
                                    </ui-alert>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-12 no-pad">

                        <!--Stage 3-->
                        <div>
                            <form class="form" @submit.prevent="setChosenAccountNumber">
                                <div>
                                    <div v-if="account !== chosenAccountNumber">
                                        <h3 class="mb-4 mt-4">
                                            <span>{{verifiedAccountNumberBreakDown.one_9}}</span>
                                            <span style="color: #c02529">
                                            {{verifiedAccountNumberBreakDown.nine_10}}
                                        </span>
                                        </h3>
                                    </div>
                                    <div v-else>
                                        <h3 class="mb-4 mt-4">
                                            {{account}}
                                        </h3>
                                    </div>
                                </div>

                                <div class="col-md-12 no-pad">
                                    <button type="submit" class="btn btn-primary btn-xnax-login ">Proceed</button>
                                </div>

                                <div class="alter-links">
                                    <a @click="changeChosenAccountNo()" class="mb-2">< Change</a>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    import VueTelInput from 'vue-tel-input';

    import {enrollmentEventBus} from "../../../main";


    export default {
        name: "stagefour",
        components: {
            VueTelInput,
        },
        props: {
            totalRequestBody: {
                type: Object,
                default: {}
            },
        },
        data () {
            return {
                createAccount: '',
                account: '',

                chosenAccountNumber: '',
                verifiedAccountNumberBreakDown: {
                    one_9: '',
                    nine_10: ''
                },

                setAccountStage: 0,

                mutableTotalRequestBody: this.totalRequestBody,

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getAppLoading',
                'startAppLoading',
                'stopAppLoading',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateEnrollComponent',
                'updateAppLoading',
            ]),

            createAccountType(no){
                //    type 1
                if (no === '1'){
                    // console.log('create account type 1');
                    this.setAccountStage = 1;
                }
                //    type 2
                else if (no === '2'){
                    // console.log('create account type 2');
                    this.createAccount = 'YES';

                    this.mutableTotalRequestBody.createaccount = this.createAccount;

                    enrollmentEventBus.$emit('totalRequestBodyUpdated', this.mutableTotalRequestBody);

                    // console.log('Current Total Body Request(P SetAccount) ===>>>',this.mutableTotalRequestBody);

                    //    switch pages/stages
                    this.updateEnrollComponent('stagefive')
                }
            },
            verifyChosenAccountNumber(){
                if(this.chosenAccountNumber.length === 10){
                    //start running
                    this.updateAppLoading(true)

                    // console.log('Chosen Account Number',this.chosenAccountNumber);
                    axios
                        .post('/suggestaccountnumber', {
                            accountnumber: this.chosenAccountNumber,
                        }, {
                            headers : {
                                'Authorization': '',
                                // 'Content-Type': 'application/json',
                                // 'Access-Control-Allow-Origin': '*'
                            }
                        })
                        .then(response => {
                            let responseData = response.data;
                            this.verifiedAccountNumber = responseData.accountnumber;

                            this.verifiedAccountNumberBreakDown.one_9 = this.verifiedAccountNumber.substring(0, 9);
                            this.verifiedAccountNumberBreakDown.nine_10 = this.verifiedAccountNumber.charAt(this.verifiedAccountNumber.length - 1);

                            // console.log('breakdown >>>>',this.verifiedAccountNumberBreakDown);

                            // console.log('Returned Acct Number >>>', responseData.accountnumber);

                            //stop running
                            this.updateAppLoading(false)

                            this.account = responseData.accountnumber;

                            this.setAccountStage = 2;
                            // this.generated = true
                        })
                }
            },
            changeChosenAccountNo(){
                this.setAccountStage = 1;
                this.account = ''
            },
            setChosenAccountNumber(){
                this.createAccount = 'YES';

                this.mutableTotalRequestBody.createaccount = this.createAccount;
                this.mutableTotalRequestBody.accountnumber = this.account;

                enrollmentEventBus.$emit('totalRequestBodyUpdated', this.mutableTotalRequestBody);

                // console.log('Current Total Body Request(P SetAccount 2) ===>>>',this.mutableTotalRequestBody);


                //    switch pages/stages
                this.updateEnrollComponent('stagefive')
            },

            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            goHome(){
                //Route to Login page
                this.$router.push('/');
            },
        },
    }
</script>

<style scoped>
    .checkbox-row{
        padding: 0;
        margin-bottom: 30px;
    }
    .checkbox-row .main-big{
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #171717;
    }
    .checkbox-row .sub-small{
        color: #570404;
        font-size: 10px;
        display: block;
        color: #6e6e6e;
    }
    .checkbox-container .checkbox-label {
        margin: 0 0 0 10px;
    }
    .login-rubies .alter-links a {
        text-align: center;
    }
    .no-pad{
        padding: 0!important;
    }
    .pageHeaderP {
        line-height: 1.7;
        color: #350304;
        font-size: 12px;
        font-weight: 300;
        margin-bottom: 5px;
    }
</style>